
import TargetSelectionItems from "../../component/ReportBuilder/MarketExplorer/TargetSelectionItems";
import OneIntelligenceServices from "../../services/OneIntelligence.services";
import ReportsServices from "../../services/Reports.services";
import { addBuildTarget, addBuildTargetGroup, setConfigSelectedBehavior, setConfigSelectedTarget, setMarketExplorerFromLoadedJson, setStep, setToEditData, updateBuildItemTargets } from "../../store/components/MarketExplorer.slice";
import { setReportBuilderMode } from "../../store/components/ReportBuilder.slice";
import { resetReportState, setWhitespacePieList, setWhitespaceSegmentSizes } from "../../store/components/Reports.slice";
import store from "../../store/store";
import getState, { arrayObjectToCSV, cleanString, createPromise, downloadCSV, dynamicSort, formatNumber, generateGUID, isArray, isDev } from "../MainHelper.js";
import { loadFreeFormReports, loadFullMarketReports, loadGenerateGrid, loadMarketCategoryReports, loadSingleCategoryReports } from "../report/ReportsHelper";
import { SAscore } from "../../hardcode/SA.score"
import ConfigServices from "../../services/Config.services";
import { behaviorMatchColors } from "../../config/Colors.config";
import { activelyInterestedObj, audienceSpicificColumns, consciouslyReceptiveObj, deepDiveColumns, highlyEngagedObj, specificMarketColumns, subConsciouslyReceptiveObj, unAwareObj } from "../../config/TableColumns.config"
import WhiteSpaceServices from "../../services/WhiteSpace.services";
import { romanize } from "../../customcomponents/customtable/CustomTable";
import MarketExplorerServices from "../../services/MarketExplorer.services";
import MainServices from "../../services/Main.services";
import WorkerServices from "../../services/Worker.services";
import { setBuildTargetFromLoadedJson } from "../../store/components/BuildTargets.slice";
import { resetInsightsState } from "../../store/components/Insights.slice";
import AudienceServices from "../../services/Audience.services"
import { notification } from "antd";
import { getWhiteLabelDictionary } from "../whitelabel/WhiteLabel.Helper.js";

export const getTranslation = (text) => {
    if (text.split(" : ").length > 1) {
        return text.split(" : ")[1];
        // return text.split(" : ")[0];
    }
    return text;
};

export const getCountry = (mpObject) => {
    const { setup, countryListObj } = getState().buildTargets;
    const marketPackage = mpObject || setup.marketPackage;
    if (!marketPackage) return [];
    return [...(countryListObj?.[marketPackage?.code] || [])].sort(dynamicSort("name"));
};

export const getMasterSize = () => {
    const state = getState();;
    const { masterSize } = state.reports;
    return masterSize;
};

export const isDisplayTreeMap = () => {
    const moduleCode = getModuleCode();
    return ["insights", "patient_marketscan", "hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "expertmedia", "patientattributes"].includes(moduleCode);
}

export const parseReportData = (fullData, selections, category, masterSize, selectionsDetails, summary) => {
    const countryCode = getCountryCode("enterprise")
    return ConfigServices.getInitialScore(countryCode).then((resp) => {
        return WorkerServices.parseReportData([{
            fullData,
            initialScore: resp,
            tempTargetAudinece: ReportsServices.getMastersTargetAudience(),
            countryCode,
            masterSize: masterSize || getMasterSize(),
            masters: ReportsServices.getMasters(true),
            selections,
            selectionsDetails,
            category,
            showZero: getShowZero(),
            analysis: getSelectedAnalysis(),
            summary
        }]);
    });
}

export const analysisPermissions = (key) => {
    const state = getState();;
    const {
        analysisAccessPerModule, setup: {
            marketPackage,
            country
        }
    } = state.buildTargets;
    if (!analysisAccessPerModule.modules) return false;
    const { modules: analysisModules } = analysisAccessPerModule;
    const foundMarketPackage = Object.values(analysisModules).find((obj) => obj.code.replace("ana_", "") === marketPackage.parent.code);
    if (!foundMarketPackage || !foundMarketPackage.modules) return false;
    const foundSubMarketPackage = Object.values(foundMarketPackage.modules).find((obj) => obj.code.replace("ana_", "") === marketPackage.code);
    if (!foundSubMarketPackage || !foundSubMarketPackage.modules) return false;
    const foundAnalysis = Object.values(foundSubMarketPackage.modules).find((obj) => obj.code.split("__")[1] === key);
    if (!foundAnalysis || !foundAnalysis.modules) return false;
    return Object.values(foundAnalysis.modules).find((obj) => obj.name === country.name);
};

export const getPackageObj = () => {
    const state = getState();;
    const { marketPackage } = state.buildTargets.setup;
    return marketPackage;
};
export const getPackage = () => {
    const state = getState();;
    try {
        const { marketPackage } = state.buildTargets.setup;
        return marketPackage.parent.oiCode || marketPackage.parent.io_code || marketPackage.parent.oi_code;
    } catch (error) {
        return "";
    }
};

export const getOICode = () => {
    return getPackage();
};

export const getMarketPackageCode = () => {
    const { setup } = getState("buildTargets");
    try {
        const { marketPackage } = setup;
        return marketPackage.parent.code.replace("dev", "");
    } catch (error) {
        return "";
    }
};

export const getMarketPackageName = () => {
    const { setup } = getState("buildTargets");
    try {
        const { marketPackage } = setup;
        return marketPackage?.parent?.title || marketPackage?.parent?.name || ""
    } catch (error) {
        return "";
    }
};

export const getModule = () => {
    const { setup } = getState("buildTargets");
    try {
        const { marketPackage } = setup;
        return marketPackage
    } catch (error) {
        return {};
    }
}

export const getModuleName = (givenObj) => {
    try {
        const moduleObj = givenObj || getModule()
        if (moduleObj?.code === "patient_marketscan") return "Patient Media Planning"
        if (moduleObj?.code === "hcp_marketscan") return "HCP Media Planning"
        if (moduleObj?.code === "icd10") return "ICD-10"
        if (moduleObj?.code === "politicaltaxonomy") return "Government Taxonomy"
        return moduleObj?.title || moduleObj?.name || ""
    } catch (error) {
        return "";
    }
}

export const getModuleCode = () => {
    try {
        const module = getModule()
        return module.code.replace("dev", "");
    } catch (error) {
        return "";
    }
};

export const getMarketPackage = () => {
    const OICode = getOICode()
    return OICode === "pharma" ? "USIG - Pharma.folder" : "USIG - Consumer.folder";
};

export const getCountryCode = (letter = 2, countryObj) => {
    const state = getState();;
    const { country } = state.buildTargets.setup;
    const tempObj = (countryObj || country)
    if (letter === "enterprise") return tempObj.enterpriseCode;
    if (letter === "savant") return tempObj.savantCode;
    if (letter === 2) return tempObj["2letterCode"];
    return tempObj["3letterCode"]
};

export const userRequestQueue = () => {
    return window.sq.oneintel.request_queue
}
export const userResponseQueue = () => {
    return window.sq.oneintel.response_queue
}
export const getCountrySQSURL = (fnc = "") => {
    const useXML = isCountryXMLAvailable()
    const useMongo = isCountryMongoAvailable()
    if (useXML) {
        if (fnc.toLocaleLowerCase() === "algo1") {
            return `${useXML}-algo1`;
        }
        if (window.useInternalLink) {
            return `${useXML}-cacher`;
        }
        return useXML;
    } else if (useMongo) {
        if (fnc.toLocaleLowerCase() === "algo1") {
            return `${useMongo}-algo1`;
        }
        if (window.useInternalLink) {
            return `${useMongo}-cacher`;
        }
        return useMongo;
    }

    return "https://sqs.ap-southeast-1.amazonaws.com/788016873502/oi-main";
};

export const isCountryMongoAvailable = () => {
    const { sqsUrlMongo, mongoAvailable } = OneIntelligenceServices.getSavantCountryObj(getCountryCode("savant"));

    return mongoAvailable && sqsUrlMongo;
};

export const isCountryXMLAvailable = (selectedCountry) => {
    const { sqsUrlXML, xmlAvailable } = OneIntelligenceServices.getSavantCountryObj(getCountryCode("savant", selectedCountry));

    return xmlAvailable && sqsUrlXML;
};

export const getShowZero = () => {
    return true
};
export const getCountryLimit = () => {
    return 1000
};

export const getCountryIndexSize = () => {
    const state = getState();;
    const { country } = state.buildTargets.setup;
    const { indexSize } = country?.attribute || {};
    return indexSize;
};

export const getCountryFinalCut = () => {
    return 0;
};
export const getCountryHardCodePackage = () => {
    const state = getState();;
    const { country } = state.buildTargets.setup;
    const { hardcodePackage } = country?.attribute || {};
    return hardcodePackage;
};

export const getServer = () => OneIntelligenceServices.getSavantCountryObj(getCountryCode("savant"));

export const fGetBehaviorMatchAndColor = (score) => {
    let behaviormatch = "";
    let color = "";
    let bg = "";
    if (score > 0.05 && score <= 0.1) {
        const { key, title } = subConsciouslyReceptiveObj
        // behaviormatch = getWhiteLabelDictionary(key, title);
        behaviormatch = title
        color = behaviorMatchColors[3];
        bg = "#FEF2F2";
    } else if (score > 0.1 && score <= 0.2) {
        const { key, title } = consciouslyReceptiveObj
        // behaviormatch = getWhiteLabelDictionary(key, title);
        behaviormatch = title
        color = behaviorMatchColors[2];
        bg = "#FFF7ED";
    } else if (score > 0.2 && score <= 0.4) {
        const { key, title } = activelyInterestedObj
        // behaviormatch = getWhiteLabelDictionary(key, title);
        behaviormatch = title
        color = behaviorMatchColors[1];
        bg = "#EFF6FF";
    } else if (score > 0.4) {
        const { key, title } = highlyEngagedObj
        // behaviormatch = getWhiteLabelDictionary(key, title);
        behaviormatch = title
        color = behaviorMatchColors[0];
        bg = "#ECFDF5";
    } else if (!behaviormatch) {
        const { key, title } = unAwareObj
        // behaviormatch = getWhiteLabelDictionary(key, title);
        behaviormatch = title
        color = behaviorMatchColors[3];
        bg = "#FEF2F2";
    }
    return {
        behaviormatch,
        color,
        bg
    };
};

export const fRenderShare = (children) => {
    if (!children.length) return "";

    const max = children.reduce((a, b) => {
        if (b.audienceIntersect === 0) return a;
        return Math.max(a, b.audienceIntersect);
    }, -Infinity);
    const ave = children.reduce((p, c) => {
        if (c.audienceIntersect === 0) return p;
        return p + (c.audienceIntersect - (c.audienceIntersect ** 2 / p));
    }, max);
    const value = Math.ceil(ave / 1000);
    if (isNaN(value)) return 0;
    return `${value.toLocaleString()}K`;
};

export const fGetInterestLevel = (children) => {
    const ave = children.reduce((p, c) => p + c.score, 0) / children.length;
    return ave * 100;
};

export const fGetDashboardJSON = (filename) => {
    const {
        buildTargets, reportBuilder, marketExplorer, reports
    } = getState();;
    const { username, fullname } = MainServices.userDetails();
    const account = MainServices.getAccount()

    return WorkerServices.parseReportJSONtoSave([{
        account,
        username,
        fullname,
        buildTargets,
        reportBuilder,
        marketExplorer,
        reports,
        filename
    }]);
};

export const downloadSummaryCSV = () => {
    const {
        whitespaceSummary: {
            topWhitespace,
            topBrandSpace
        }
    } = getState("reports");

    let columns = [{
        title: "Name",
        key: "name"
    }, {
        title: "Score",
        key: "newFormulaScore"
    }, {
        title: "Path",
        key: "location"
    }];

    const parseToGetChildren = (list) => {
        return list.reduce((acc, item) => {
            acc.push(item);
            if (item.tempChildren) {
                item.tempChildren.forEach((child) => {
                    acc.push(child);
                })
            }
            return acc
        }, [])
    }
    const renderer = (rowData) => {
        return {
            ...rowData,
            newFormulaScore: rowData.newFormulaScore || 0,
            location: (rowData.parentPath || "").split("/").map((path) => {
                return path.split("~~")[1]
            }).join("/")
        }
    }

    downloadCSV("Top whitespace", arrayObjectToCSV({
        data: parseToGetChildren(topWhitespace),
        columns
    }, renderer))

    downloadCSV("Top brandspace", arrayObjectToCSV({
        data: parseToGetChildren(topBrandSpace),
        columns
    }, renderer))
}
export const downloadWhitespaceCompetitor = (master, competitorCheckedCategories, objValues) => {
    // states
    const state = getState();
    const { generateGrid, currentWhitespaceTree } = state.reports;

    let columns = [{
        title: "#",
        key: "num"
    }, {
        title: "Data Level",
        key: "datalevel"
    }, {
        title: "Candidate Whitespace",
        key: "title"
    }, {
        title: master + (competitorCheckedCategories.length ? " vs Selected Competitors" : ""),
        key: "diff"
    }];

    const renderer = (rowData) => {
        const tempRowData = { ...rowData };
        tempRowData.diff = formatNumber(tempRowData.diff, 2) + "%"

        const paths = (tempRowData?.namePath || tempRowData?.path)?.split("/")?.length || 1;
        if (paths === 1) tempRowData.datalevel = "category";
        else if (paths === 2) tempRowData.datalevel = "subcategory";
        else tempRowData.datalevel = "segment";

        if (tempRowData.name.trim() === ">") {
            tempRowData.name = tempRowData.title
        }
        return tempRowData
    };

    return WorkerServices.whitespaceDynamic("downloadCSVWSCompetitor", [generateGrid, currentWhitespaceTree, competitorCheckedCategories, objValues]).then((data) => {
        downloadCSV("Competitor", arrayObjectToCSV({
            data,
            columns,
        }, renderer));
    });
}


//Note: jehu
const downloadWhitespaceReport = async (isDevVal, secondReport) => {
    // states
    const state = getState();
    const { generateGrid, whitespacePieValues } = state.reports;
    const { currentWhitespaceTree } = state.reports;
    let brandCols = [];

    // functions
    const renderer = (rowData) => {
        const tempRowData = { ...rowData };
        if (isDevVal && !secondReport) {
            const paths = (tempRowData?.namePath || tempRowData?.path).split("/").length;
            let datalevel = "segment";
            if (paths === 1) datalevel = "category";
            else if (paths === 2) datalevel = "subcategory";

            if (tempRowData.name.trim() === ">") {
                tempRowData.name = tempRowData.title
            }

            return {
                ...Object.keys(rowData).reduce((acc, key) => {
                    const value = rowData[key];
                    if (["brandSpace", "diff"].includes(key)) {
                        if (isDevVal && !secondReport) {
                            acc[key] = `${value.toFixed(2)}%`;
                        } else {
                            acc[key] = value < 0 ? 0 : `${value.toFixed(2)}%`;
                        }
                    } else if (!["brandSpace", "diff", "num", "name", "segmentSize"].includes(key)) {
                        acc[key] = `${(value * 100).toFixed(2)}%`;
                    } else {
                        acc[key] = value;
                    }
                    return acc;
                }, {}),
                datalevel
            }
        }

        tempRowData.diff = rowData.diff < 0 ? 0 : `${rowData.diff.toFixed(2)}%`;
        tempRowData.brandSpace = rowData.brandSpace < 0 ? 0 : `${rowData.brandSpace.toFixed(2)}%`;
        tempRowData.avebrands_raw = `${((rowData.avebrands_raw || 0) * 100).toFixed(2)}%`;
        tempRowData.avegenerics_raw = `${((rowData.avegenerics_raw || 0) * 100).toFixed(2)}%`;
        tempRowData.segmentSize = `${formatNumber(rowData.segmentSize || 0)}`;
        tempRowData.targetSize = `${formatNumber(rowData.targetSize || 0)}`;

        const paths = (tempRowData?.namePath || tempRowData?.path)?.split("/")?.length || 1;
        if (paths === 1) tempRowData.datalevel = "category";
        else if (paths === 2) tempRowData.datalevel = "subcategory";
        else tempRowData.datalevel = "segment";

        if (tempRowData.name.trim() === ">") {
            tempRowData.name = tempRowData.title
        }

        return brandCols.reduce((acc, objCol) => {
            const { title, key } = objCol;
            const { value } = whitespacePieValues[rowData.path] || {};
            if (rowData.path.split("/").length > 1) {
                const listOfDependencies = Object.keys(whitespacePieValues).filter((keyT) => keyT.includes(rowData.path));
                if (rowData.path.split("/").length === 2 && rowData.children && listOfDependencies.length <= 1) {
                    acc[key] = "";
                    return acc;
                }
            }
            const foundObj = (value || []).find((d) => d.title === title);
            if (foundObj) {
                acc[key] = `${(foundObj.score).toFixed(2)}%`;
            } else {
                acc[key] = "";
            }
            return acc;
        }, { ...tempRowData });
    };

    await WorkerServices.downloadCSVWS([generateGrid, isDevVal, secondReport, currentWhitespaceTree]).then((res) => {
        if (res) {
            const { filename, data, columns, newBrandCols } = res;
            brandCols = newBrandCols;
            downloadCSV(filename, arrayObjectToCSV({
                data,
                columns,
            }, renderer));
        }
    });
}

export const downloadRecommendationItem = (data) => {
    const resultTextTop = arrayObjectToCSV({
        data: [
            {
                name: "Name",
                value: data.name
            },
            {
                name: "Interest Level",
                value: data.interestLevel
            },
            {
                name: "Target Audience",
                value: data.targetAudience
            },
            {
                name: "Size",
                value: formatNumber(data.targetSize)
            },
            {
                name: "",
                value: ""
            },
            {
                name: "",
                value: ""
            }
        ],
        columns: [{
            title: "",
            key: "name"
        }, {
            title: "",
            key: "value"
        }]
    });
    const resultTextList = arrayObjectToCSV({
        data: data.list,
        columns: [{
            title: "Category",
            key: "discoveredCategory"
        }, {
            title: "Behaviors",
            key: "count"
        }, {
            title: "Size",
            key: "size"
        }]
    }, (rowData) => ({
        ...rowData,
        count: rowData.children ? rowData.children.length : "",
        size: rowData.size ? formatNumber(rowData.size) : ""
    }));
    downloadCSV(data.name, resultTextTop + resultTextList);
}

export const fDownloadReportCSV = () => {
    const state = getState();
    const {
        setup: {
            marketPackage
        }
    } = state.buildTargets;
    const {
        generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData,
        subItemsDataPerGroup, lowerLevelPerGroup } = state.reports;

    const moduleCode = getModuleCode()
    const analysis = getSelectedAnalysis()

    if (["globalwebindex", "customerbehavior"].includes(moduleCode)) {
        const list = Object.values(lowerLevelPerGroup).reduce((acc, item) => {
            acc = acc.concat(item.data)
            return acc
        }, [])
        if (list.length) {
            fDownloadLowerLevelCSV(list, "Category Deep Dive")
        } else {
            notification.warning({
                message: "Download CSV",
                description: "Nothing to download",
                placement: "topRight",
            });
        }
        return
    }


    if ((marketPackage?.parent?.code || "").replace("dev", "")
        === "whitespaces") {
        downloadWhitespaceReport(isDev())
    } else if (generalMarketCategoriesData.length) {
        const generalMarket = arrayObjectToCSV({
            data: generalMarketCategoriesData,
            columns: specificMarketColumns
        }, (rowData) => ({
            ...rowData,
            score: `${(rowData.score * 100).toFixed(2)}%`,
            share: formatNumber(rowData.share)
        }));
        downloadCSV("General Market Categories", generalMarket);
    }

    if (audienceSpecificCategoriesData.length) {
        const audienceSpicific = arrayObjectToCSV({
            data: audienceSpecificCategoriesData,
            columns: audienceSpicificColumns
        }, (rowData) => ({
            ...rowData,
            score: `${(rowData.score * 100).toFixed(2)}%`,
            share: formatNumber(rowData.share)
        }));
        downloadCSV("Audience Specific Categories", audienceSpicific);
    }

    if (categoryDeepDiveData.length) {
        const cols = [{
            title: "#",
            key: "num"
        }];
        if (isDev()) {
            cols.push({
                title: "Path",
                key: "namePath"
            })
        }
        cols.push({
            title: "Group",
            key: "group"
        })
        deepDiveColumns.forEach((col) => {
            if (col.excludeDownloadWhenModule) {
                if (!col.excludeDownloadWhenModule.includes(moduleCode)) cols.push(col)
                return false
            }
            if (col.excludeDownloadWhenAnalysis && !col.excludeDownloadWhenAnalysis.includes(analysis.key)) {
                cols.push(col)
            } else if (!col.excludeDownloadWhenModule && col.type !== "value" && col.csv !== false) {
                cols.push(col)
            }
        })

        const parsedData = categoryDeepDiveData.reduce((acc, groupObj) => {
            const { children, discoveredCategory, namePath } = subItemsDataPerGroup[groupObj.group] || groupObj;
            let paths = ""
            try {
                paths = namePath.split("/");
                paths = paths.length > 1 ? paths[0] : ""
            } catch (error) {
                paths = ""
            }
            acc = acc.concat(children.map((item, idx) => ({
                num: acc.length + (idx + 1),
                ...item,
                group: discoveredCategory,
                namePath: paths,
                ...fGetBehaviorMatchAndColor(item.score),
                score: `${(item.score * 100).toFixed(2)}%`,
                share: formatNumber(item.share),
                audienceIntersect: formatNumber(item.audienceIntersect)
            })));
            return acc;
        }, []);
        downloadCSV("Category Deep Dive", arrayObjectToCSV({
            data: parsedData,
            columns: cols
        }));
    }
};

export const fDownloadLowerLevelCSV = (groupList, filename) => {
    if (groupList.length) {
        let longtestPath = []
        const newList = groupList.reduce((acc, group) => {
            group.children.forEach((child, idx) => {
                if (!child.path) return
                const paths = child.path.split("/");
                if (paths.length > longtestPath.length) longtestPath = paths

                let catCount = 1
                const otherProperty = paths.reduce((obj, key, iidd) => {
                    if (iidd === paths.length - 1) return obj
                    const path = paths[catCount - 1]
                    obj[`category${catCount}`] = path.split("~~").length > 1 ? path.split("~~")[1] : path
                    catCount += 1
                    return obj
                }, {})
                acc.push({
                    num: acc.length + (idx + 1),
                    ...child,
                    ...fGetBehaviorMatchAndColor(child.score),
                    score: `${(child.score * 100).toFixed(2)}%`,
                    share: formatNumber(child.share),
                    audienceIntersect: formatNumber(child.audienceIntersect),
                    ...otherProperty
                })
            })
            return acc
        }, [])

        const cols = [{
            title: "#",
            key: "num"
        }];
        longtestPath.forEach((key, idx) => {
            if (!idx) {
                cols.push({
                    title: "Category",
                    key: "category1"
                })
            } else if (idx === longtestPath.length - 1) {
                cols.push({
                    title: "Behavior",
                    key: "item"
                })
            } else {
                cols.push({
                    title: `Sub-Category ${idx}`,
                    key: `category${idx + 1}`
                })
            }
        })

        cols.push({
            title: "Behavior Match",
            key: "behaviormatch"
        })
        cols.push({
            title: "Interest Level",
            key: "score"
        })
        cols.push({
            title: "Segment Size",
            key: "share"
        })
        cols.push({
            title: "Target Size",
            key: "audienceIntersect"
        })

        downloadCSV(filename, arrayObjectToCSV({
            data: newList,
            columns: cols
        }));
    }
};

export const getAllKeywordsInFolder = (items, childrenList = [], removeSpecialChar) => {
    (items || []).forEach((child) => {
        if (child.isElement) return
        let childName = child.name.toLocaleLowerCase();
        if (removeSpecialChar) {
            childName = cleanString(childName);
        }
        const childList = child.children || child.tempChildren;
        if (!childList) {
            if (!childrenList.includes(childName)) { childrenList.push(childName); }
        }
        if (childList && childList.length) {
            getAllKeywordsInFolder(childList, childrenList, removeSpecialChar);
        }
    });
    return childrenList;
};

export const getStepToDisplay = (item, audId, isFirst) => {
    const state = getState();;
    const { configuration: { toEditData, buildedTargets } } = state.marketExplorer;

    const getCurrentStep = ({ code, steps }) => {
        const [fistStep] = steps;
        if (!buildedTargets.length || isFirst) {
            return fistStep.subSteps || fistStep;
        }
        let idAudience = audId;
        if (!audId) {
            const { audienceId } = toEditData.data;
            idAudience = audienceId;
        }
        const find = buildedTargets.find((audience) => audience.key === idAudience);
        if (find) {
            let foundNextStep = steps.filter((step) => !find.groups.find((group) => group.code.split("~")[0] === step.code));
            if (foundNextStep && foundNextStep.length === 1) foundNextStep = foundNextStep[0];
            if (foundNextStep) {
                if (foundNextStep.subSteps) {
                    const filterSubSteps = foundNextStep.subSteps.filter((substep) => !find.groups.find((group) => group.code.split("~")[0] === substep.code));
                    if (filterSubSteps.length !== foundNextStep.subSteps.length) return true
                }
                return foundNextStep;
            }
            return {
                text: "Done All Steps",
                code,
                stepEnd: true,
                description: "Short text to guide users about this option."
            };
        }
        return fistStep.subSteps || fistStep;
    };

    if (item?.type === "steps") {
        return getCurrentStep(item);
    }
    return false;
};

export const checkIfTargetAlreadyInGroup = (code) => {
    const state = getState();;
    const marketPackageCode = getMarketPackageCode();
    const moduleCode = getModuleCode()

    if (["aitag"].includes(marketPackageCode) || ["facebookaudiences"].includes(moduleCode)) return false;
    const {
        configuration: {
            toEditData, buildedTargets
        }
    } = state.marketExplorer;
    const { audienceId } = toEditData.data;
    const find = buildedTargets.find((audience) => audience.key === audienceId);
    if (find) {
        return !!find.groups.find((group) => group.code === code);
    }
    return false;
};

export const checkToDisabled = (code) => {
    const state = getState();;
    const {
        configuration: { selectedTargetFocus, toEditData }
    } = state.marketExplorer;
    if (toEditData.data) {
        return checkIfTargetAlreadyInGroup(code);
    }
    const moduleCode = getModuleCode();
    if (["hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "expertmedia"].includes(moduleCode.replace("dev", ""))) {
        // if (code === "mokb_marketexplorer") return false
        if (code !== "target_focus") {
            return !selectedTargetFocus;
        }
    }
    return false;
};

export const renderTargetSelectionItems = (item, onClick, options = {}, showTheUsual = true) => {
    if (!item) return null
    const { isFirst, isDisabled } = options;
    const moduleCode = getModuleCode();
    if (!showTheUsual && ["healthcarewhitespaces", "veterinaryjourney", "whitespacesmodule"].includes(moduleCode) && item.steps) {
        const foundSubSteps = item.steps.find((s) => s.subSteps);
        const list = handleDisabled(foundSubSteps.subSteps);
        return <>
            {list.map((sub) => (
                <TargetSelectionItems
                    key={sub.code}
                    data={sub}
                    onClick={onClick}
                />
            ))}
        </>
    }
    const result = getStepToDisplay(item, isFirst);
    if (result === true) return null;
    let newItemObj = result === false ? item : result;

    if (isArray(result)) {
        return (
            <>
                {result.map((sub) => {
                    let tempSub = sub
                    if (usergroupNoAccess(sub)) {
                        if (tempSub.accessType) {
                            tempSub = {
                                ...tempSub,
                                noAccess: true
                            }
                        }
                    }
                    return (
                        <TargetSelectionItems
                            key={tempSub.code}
                            data={tempSub}
                            onClick={onClick}
                            disabled={isDisabled || checkToDisabled(tempSub.code)}
                        />
                    )
                })}
            </>
        );
    }
    if (!newItemObj) return null

    if (usergroupNoAccess(newItemObj)) {
        if (newItemObj.accessType) {
            newItemObj = {
                ...newItemObj,
                noAccess: true
            }
        }
    }
    return (
        <TargetSelectionItems
            key={newItemObj?.code}
            data={newItemObj}
            onClick={onClick}
            disabled={isDisabled || checkToDisabled(newItemObj?.code)}
        />
    );
};

export const filterSelections = (arr = [], audId) => {
    const state = getState();;
    const { setup } = state.buildTargets;
    const account = MainServices.getAccount();
    const usergroup = MainServices.getUserGroup();
    const { configuration: { buildedTargets, toEditData } } = state.marketExplorer;
    const countryCode = !setup.country ? null : getCountryCode("enterprise");
    const filtered = arr.reduce((acc, item) => {
        const {
            availableIn, availableInUserGroups, packages, mpModule, mpModuleHide, country, accessType
        } = item;
        const OICode = setup?.marketPackage?.parent?.oiCode;
        const moduleCode = setup?.marketPackage?.code.replace("dev", "");
        if (!packages || !packages.includes(OICode)) return acc;
        if (mpModule && !mpModule.includes(moduleCode)) return acc;
        if (mpModuleHide && mpModuleHide.includes(moduleCode)) return acc;
        if (country && !country.includes(countryCode)) return acc;
        if (availableIn && availableIn.length) {
            if (!availableIn.includes(account)) {
                if (usergroupNoAccess(item)) {
                    if (accessType) {
                        acc.push({
                            ...item,
                            noAccess: true
                        })
                    }
                    return acc;
                }
            }
        } else {
            if (usergroupNoAccess(item)) {
                if (accessType) {
                    acc.push({
                        ...item,
                        noAccess: true
                    })
                } return acc;
            }
        }
        acc.push(item)
        return acc;
    }, []);

    if (!buildedTargets.length) {
        return filtered;
    }

    const orDisplay = filtered.filter((item) => item.typeToDiplay === "or");
    if (orDisplay.length) {
        let idAudience = audId;
        if (!audId) {
            const { audienceId } = toEditData.data;
            idAudience = audienceId;
        }
        const find = buildedTargets.find((audience) => audience.key === idAudience);
        if (find) {
            const currentStep = orDisplay.find((step) => find.groups.find((group) => group.parentCode === step.code));
            if (currentStep) {
                return filtered.filter((item) => {
                    if (item.typeToDiplay !== "or") return true;
                    if (currentStep.code === item.code) return true;
                    return false;
                });
            }
        }
    }
    return filtered;
};

export const sortSelectionsPerSeqNo = (buildTargets, behaviorList) => {
    const moduleCode = getModuleCode();
    const list = [...buildTargets, ...behaviorList];
    const hasNoSeqNo = list.find((item) => {
        if (!item.sequence) return true
        if (!item.sequence[moduleCode]) return true
        return false
    });
    if (hasNoSeqNo) return {
        buildTargets,
        behaviorList
    }
    return {
        buildTargets: [],
        behaviorList: list.sort((a, b) => a.sequence[moduleCode] - b.sequence[moduleCode])
    }
}

const usergroupNoAccess = (item) => {
    const usergroup = MainServices.getUserGroup();
    const { disabledMOKB } = getState("feature")
    const { code, availableInUserGroups } = item

    if (code?.toLocaleLowerCase()?.includes("mokb_")) {
        const hasMOKBAppAccess = (MainServices?.userDetailsCache?.appList || []).find((d) => d.id === 25);
        if (hasMOKBAppAccess) {
            return disabledMOKB
        }
        return !hasMOKBAppAccess
    }
    return availableInUserGroups && availableInUserGroups.length && !availableInUserGroups.includes(usergroup)
}

export const handleDisabled = (list) => {
    const OICode = getOICode();
    const moduleCode = getModuleCode();
    const countryCode = getCountryCode("enterprise")
    const account = MainServices.getAccount();
    const usergroup = MainServices.getUserGroup();
    return list.reduce((acc, item) => {
        const {
            availableIn, availableInUserGroups, packages, mpModule, mpModuleHide, country, accessType
        } = item;
        if (availableIn && availableIn.length) {
            if (!availableIn.includes(account)) {
                if (usergroupNoAccess(item)) {
                    if (accessType) {
                        acc.push({
                            ...item,
                            noAccess: true
                        })
                    }
                    return acc;
                } else if (accessType) {
                    acc.push(item)
                }
                return acc;
            }
        } else {
            if (usergroupNoAccess(item)) {
                if (accessType) {

                    acc.push({
                        ...item,
                        noAccess: true
                    })
                } return acc;
            }
        }
        if (!packages || !packages.includes(OICode)) return acc;
        if (mpModule && !mpModule.includes(moduleCode)) return acc;
        if (mpModuleHide && mpModuleHide.includes(moduleCode)) return acc;
        if (country && !country.includes(countryCode)) return acc;
        acc.push(item)
        return acc;
    }, []);
}
export const filterSelectionsToDisabled = () => {
    const state = getState();;
    const account = MainServices.getAccount();
    const usergroup = MainServices.getUserGroup();
    const moduleCode = getModuleCode();
    const { setup } = state.buildTargets;
    const { configuration: { buildedTargets } } = state.marketExplorer;
    const countryCode = getCountryCode("enterprise")
    const filtered = MarketExplorerServices.getMarketExplorerList().behavioralAndAttributes.reduce((acc, item) => {
        const {
            availableIn, availableInUserGroups, packages, mpModule, mpModuleHide, country, accessType
        } = item;
        if (availableIn && availableIn.length) {
            if (!availableIn.includes(account)) {
                if (usergroupNoAccess(item)) {
                    if (accessType) {
                        acc.push({
                            ...item,
                            noAccess: true
                        })
                    }
                    return acc;
                }
            }
        } else {
            if (usergroupNoAccess(item)) {
                if (accessType) {

                    acc.push({
                        ...item,
                        noAccess: true
                    })
                } return acc;
            }
        }
        const OICode = setup?.marketPackage?.parent?.oiCode;
        const moduleCode = setup?.marketPackage?.code.replace("dev", "");
        if (!packages || !packages.includes(OICode)) return acc;
        if (mpModule && !mpModule.includes(moduleCode)) return acc;
        if (mpModuleHide && mpModuleHide.includes(moduleCode)) return acc;
        if (country && !country.includes(countryCode)) return acc;
        acc.push(item)
        return acc;
    }, []);

    if (!buildedTargets.length) {
        return [];
    }

    if (moduleCode === "whitespacesmodule") {
        try {
            const orDisplay = filtered.filter((item) => item.typeToDiplay === "or");
            if (orDisplay.length) {
                const doneSteps = {};
                const existing = buildedTargets.reduce((acc, { groups }) => {
                    groups.forEach((group) => {
                        if (!doneSteps[group.parentCode]) doneSteps[group.parentCode] = [];
                        if (group.parentCode) {
                            acc.push(group.parentCode);
                        }
                        doneSteps[group.parentCode].push(group.code);
                    });
                    return acc;
                }, []);
                let hasDone = false;
                const result = filtered.filter((audience) => {
                    if (audience?.steps) {
                        if (doneSteps?.[audience.code]?.length === audience?.steps?.length) {
                            hasDone = true;
                        }
                    }
                    return audience;
                });
                return hasDone ? [] : result;
            }
        } catch (error) {
            return [];
        }
    } else {
        const orDisplay = filtered.filter((item) => item.typeToDiplay === "or");
        if (orDisplay.length) {
            const doneSteps = {};
            const existing = buildedTargets.reduce((acc, { groups }) => {
                groups.forEach((group) => {
                    if (!doneSteps[group.parentCode]) doneSteps[group.parentCode] = [];
                    if (group.parentCode) {
                        acc.push(group.parentCode);
                    }
                    doneSteps[group.parentCode].push(group.code);
                });
                return acc;
            }, []);
            let hasDone = false;
            const result = filtered.filter((audience) => {
                if (audience?.steps) {
                    if (doneSteps?.[audience.code]?.length === audience?.steps?.length) {
                        hasDone = true;
                    }
                }
                if (!existing.includes(audience.code)) {
                    return audience;
                }
            });
            return hasDone ? [] : result;
        }
    }
    return [];
};

export const getNextStep = (currentStep) => {
    const found = MarketExplorerServices.getMarketExplorerList().behavioralAndAttributes.find((item) => item.code === currentStep.parentCode);
    if (!found) {
        return false;
    }
    return (found.steps || []).find((step) => step.code !== currentStep.code);
};

export const getAllKeywordsInFolderObject = (items, childrenList = []) => {
    (items || []).forEach((child) => {
        if (child.isElement) return
        const childName = child.name.toLocaleLowerCase();
        const childList = child.children || child.tempChildren;
        if (!childList) {
            if (!childrenList.find((obj) => obj.key === childName)) {
                childrenList.push({
                    key: childName,
                    name: child.name,
                    variants: child.variants
                });
            }
        }
        if (childList && childList.length) {
            getAllKeywordsInFolderObject(childList, childrenList);
        }
    });
    return childrenList;
};

export const disabledAnalysisWhen = () => {
    const state = getState();;
    const { configuration: { buildedTargets } } = state.marketExplorer;
    const moduleCode = getModuleCode();
    if (["healthcarewhitespaces", "veterinaryjourney"].includes(moduleCode.replace("dev", ""))) {
        const checker = {
            wp_hcps: false,
            wp_medications: false,
            wp_generics: false,
            mokb_marketexplorer: false,
            mokb_marketexplorer_main: false
        };

        buildedTargets.forEach((aud) => {
            aud.groups.forEach((group) => {
                if (checker[group.code] !== undefined) {
                    if (group.code === "wp_generics") checker.wp_hcps = true;
                    if (group.code === "wp_hcps") checker.wp_generics = true;
                    checker[group.code] = true;
                }
            });
        });
        if (checker.wp_medications || checker.mokb_marketexplorer) {
            checker.wp_medications = true;
            checker.mokb_marketexplorer = true;
        }
        if (checker.wp_hcps || checker.wp_generics || checker.mokb_marketexplorer_main) {
            checker.wp_hcps = true;
            checker.wp_generics = true;
            checker.mokb_marketexplorer_main = true;
        }
        return Object.values(checker).includes(false);
    }
    if (["whitespacesmodule"].includes(moduleCode.replace("dev", ""))) {
        const checker = {
            wp_brands: false,
            wp_generics: false,
            mokb_marketexplorer: false,
            mokb_marketexplorer_main: false
        };

        buildedTargets.forEach((aud) => {
            aud.groups.forEach((group) => {
                if (checker[group.code] !== undefined) checker[group.code] = true;
            });
        });

        if (checker.wp_generics || checker.mokb_marketexplorer_main) {
            checker.wp_generics = true;
            checker.mokb_marketexplorer_main = true;
        }

        if (checker.wp_brands || checker.mokb_marketexplorer) {
            checker.wp_brands = true;
            checker.mokb_marketexplorer = true;
        }
        return Object.values(checker).includes(false);
    }

    return !buildedTargets.length;
};

export const checkIfHasAudieceId = (searchParams) => {
    const { dispatch } = store;
    const id = searchParams.get("audID");
    if (id) {
        return AudienceServices.getAudienceJSON(`mpcountrysetup/${id}.json`).then((respSetup) => {
            if (respSetup) {
                dispatch(setBuildTargetFromLoadedJson({ setup: respSetup }));
                return AudienceServices.getAudienceJSON(`masters/${id}.json`).then((resp) => {
                    if (resp) {
                        dispatch(setMarketExplorerFromLoadedJson({ configuration: resp }));
                        return `/report-builder/?audID=${id}`;
                    }
                    return null;
                });
            }
            return null;
        });
    }
    return Promise.resolve();
};

export const removeAllReport = () => {
    const { dispatch } = store;
    dispatch(setReportBuilderMode("select"));
    dispatch(resetReportState());
    dispatch(resetInsightsState());
    dispatch(setWhitespaceSegmentSizes({}));
    dispatch(setWhitespacePieList({ removeall: true }));
    WorkerServices.clearWhiteSpaceCache([])
    WorkerServices.clearAudienceCache([])
    WorkerServices.clearCache([])
};

export const saveTargetBuilder = (targets) => {
    const { dispatch } = store;
    const {
        marketExplorer: { configuration: { toEditData, selectedTarget, selectedBehavior } }
    } = getState();

    if (["wp_brands", "wp_medications"].includes(toEditData?.data?.code)) {
        removeAllReport();
    } else if (["wp_hcps", "wp_generics"].includes(toEditData?.data?.code)) {
        WorkerServices.clearWhiteSpaceCache([])
        WorkerServices.clearAudienceCache([])
    }
    if (toEditData.data && toEditData.mode === "edit") {
        dispatch(updateBuildItemTargets({
            audienceId: toEditData.data.audienceId,
            groupIndex: toEditData.data.groupIndex,
            targets
        }));
    } else if (toEditData.data && toEditData.mode === "and") {
        dispatch(addBuildTargetGroup({
            ...toEditData.data,
            ...selectedTarget,
            bahavior: selectedBehavior,
            targets
        }));
    } else {
        dispatch(addBuildTarget({
            name: "Audience Name 1",
            key: generateGUID(),
            groups: [{
                ...selectedTarget,
                bahavior: selectedBehavior,
                targets
            }]
        }));
    }
};

export const getSelectedAnalysis = (key) => {
    const { currentSelectedMode } = getState("reportBuilder")
    return ConfigServices.getAnalysisItem(key || currentSelectedMode)
}

export const getAvailableAnalysis = (isDisabled = false) => {
    const state = getState();
    const { setup } = state.buildTargets;
    const mpCode = getModuleCode();
    let entCode = null
    if (setup?.country) {
        entCode = getCountryCode("enterprise");
    }
    return ConfigServices.getAnalysisList(isDisabled)
    // return tempList.reduce((acc, type) => {
    //     const {
    //         showwhen, showwhenmodule, hidewhenmodule, hidewhen, available, key, availableInCountry
    //     } = type;
    //     if (showwhen && !(showwhen || []).includes(oiCode)) {
    //         return acc;
    //     }
    //     if (showwhenmodule && !(showwhenmodule || []).includes(mpCode)) {
    //         return acc;
    //     }
    //     if (hidewhenmodule && (hidewhenmodule || []).includes(mpCode)) {
    //         return acc;
    //     }
    //     if (hidewhen && (hidewhen || []).includes(oiCode)) {
    //         return acc;
    //     }
    //     let notAvailable = !available || analysisPermissions(key);
    //     if (availableInCountry && !notAvailable) {
    //         notAvailable = !availableInCountry.includes(entCode);
    //     }
    //     const disabledItem = isDisabled || notAvailable;
    //     acc.push({
    //         ...type,
    //         disabledItem,
    //         notAvailable
    //     });
    //     return acc;
    // }, []);
};

export const runReports = () => {
    const { dispatch } = store;
    const {
        reports: { generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData },
        reportBuilder: { mode }
    } = getState();

    const hasData = (generalMarketCategoriesData.length
        || audienceSpecificCategoriesData.length
        || categoryDeepDiveData.length);

    dispatch(setConfigSelectedTarget(null));
    dispatch(setConfigSelectedBehavior(null));
    dispatch(setToEditData({
        data: null,
        mode: ""
    }));
    dispatch(setStep(3));
    const marketPackageCode = getMarketPackageCode()
    if (disabledAnalysisWhen()) return
    if (hasData || (mode !== "select")) {
        if (mode === "fullmarket") {
            loadFullMarketReports();
        } else if (mode === "singlecategory") {
            loadSingleCategoryReports();
        } else if (["marketcategory", "hcpattributes", "hcpmarketscan", "petientmarketscan",
            "tiktokhastags", "analysis_gdn&trv_affinity",
            "analysis_gdn&trv_purchase",
            "analysis_gdn&trv_topic",
            "yahoo_audiences_attribute_targeting",
            "yahoo_audiences_interests",
            "yahoo_audiences_purchase_intent_targeting",
            "tiktokinterest",
            "tiktokvideointeractions",
            "purchaseintentions",
            "icd10clinicalmodification",
            "icd10procedurecodingsystem",
            "tiktokcreatorinteractions",
            "la_demographicsattributes",
            "la_behavioralattributes",
            "la_purchaseintent",
            "la_hobbiesinterests",
            "medicaljournal",
            "medicalassociations",
            "medicalwebsites",
            "medicalconferences",
            "continuingmedicaleducation"].includes(mode) || (mode === "mokb_analysis" && marketPackageCode !== "whitespaces")) {
            loadMarketCategoryReports(true);
        } else if (mode === "freeform") {
            loadFreeFormReports(true);
        } else if (["candidatewhitespaces",
            "analysis_politicaltaxonomy",
            "usersearchjourney",
            "otherwhitespaces",
            "claimswhitespaces",
            "ingredientshitespaces",
            "safetycocernsideeffectswhitespaces",
            "macrowhitespaces",
            "standardtreatmentjourney",
            "othermacrowhitespaces",
            "symptomswhitespaces",
            "mokb_analysis",
            "diagnosistreatmentwhitespaces"].includes(mode)) {
            loadGenerateGrid(true);
        }
    }
};

export const getBrandGenericsHcp = () => {
    const state = getState();
    const {
        marketPackage
    } = state.buildTargets.setup;
    const { configuration: { buildedTargets } } = state.marketExplorer;
    let brandsArray = [];
    let hcpsArray = [];
    let genericsArray = [];
    let mokbArray = [];
    buildedTargets.forEach((aud) => {
        aud.groups.forEach(({ code, targets }) => {
            if (["wp_hcps"].includes(code)) {
                hcpsArray = hcpsArray.concat(targets);
            } else if (["wp_brands", "wp_medications", "product_brand"].includes(code)) {
                brandsArray = brandsArray.concat(targets);
            } else if (["wp_generics", "wp_freeform", "mokb_marketexplorer_main"].includes(code)) {
                genericsArray = genericsArray.concat(targets);
            } else if (["mokb_marketexplorer"].includes(code)) {
                mokbArray = mokbArray.concat(targets);
            }
        });
    });
    const hcpsOrigText = {};
    const brandsOrigText = {};
    const brandsOrigTextLower = {};
    const genericsOrigText = {};
    const hcps = {};
    const brands = {};
    const brands2ndChild = {};
    const generics = {};
    const mokbs = {};
    const mokbsMicrosegments = {};

    hcpsArray.forEach((item) => {
        const childName = item.name.toLocaleLowerCase();
        const childList = item.children || item.tempChildren;
        const newList = childList ? getAllKeywordsInFolderObject(childList, hcps[childName] || []) : [{
            key: childName,
            name: item.name
        }];
        hcps[childName] = newList;
        hcpsOrigText[childName] = {
            key: childName,
            name: item.name,
            children: newList
        };
    });

    const for2ndChild = (children, parent) => {
        if (parent?.lvl === 2) {
            for2ndChild([parent]);
        } else {
            children.forEach((item) => {
                const childList = item.children || item.tempChildren;
                if (!childList) return;
                const childName = item.name.toLocaleLowerCase();
                const newList = childList ? getAllKeywordsInFolderObject(childList, brands2ndChild[childName] || []) : [{
                    key: childName,
                    name: item.name
                }];
                brands2ndChild[childName] = newList;
                const parentKey = childList ? item.name : item.parentKey.split("~~")[1];
                const perentKeyLower = parentKey.toLocaleLowerCase();
                if (!brandsOrigText[parentKey]) {
                    const obj = {
                        key: parentKey.toLocaleLowerCase(),
                        name: parentKey,
                        children: newList
                    };
                    brandsOrigText[parentKey] = obj;
                    brandsOrigTextLower[perentKeyLower] = obj;
                } else {
                    brandsOrigTextLower[perentKeyLower].children = brandsOrigTextLower[perentKeyLower].children.concat(newList);
                    brandsOrigText[parentKey].children = brandsOrigText[parentKey].children.concat(newList);
                }
            });
        }
    };
    const entCode = getCountryCode("enterprise");
    brandsArray.forEach((item) => {
        const childName = item.name.toLocaleLowerCase();
        const childList = item.children || item.tempChildren;
        if (childList && (["jpn"].includes(entCode) || marketPackage?.code?.replace("dev", "") === "healthcareclaims")) for2ndChild(childList, item);
        const newList = childList ? getAllKeywordsInFolderObject(childList, brands[childName] || []) : [{
            key: childName,
            name: item.name
        }];
        brands[childName] = newList;
        const parentKey = childList ? item.name : item.parentKey;
        const perentKeyLower = parentKey.toLocaleLowerCase();
        if (!brandsOrigText[parentKey]) {
            const obj = {
                key: parentKey.toLocaleLowerCase(),
                name: parentKey,
                children: newList
            };
            brandsOrigText[parentKey] = obj;
            brandsOrigTextLower[perentKeyLower] = obj;
        } else {
            brandsOrigText[parentKey].children = brandsOrigText[parentKey].children.concat(newList);
            brandsOrigTextLower[perentKeyLower].children = brandsOrigTextLower[perentKeyLower].children.concat(newList);
        }
    });

    mokbArray.forEach((item) => {
        const childName = item.name.toLocaleLowerCase();
        const childList = item.children || item.tempChildren;
        const newList = childList ? getAllKeywordsInFolderObject(childList, mokbs[childName] || []) : [{
            key: childName,
            name: item.name
        }];
        mokbs[childName] = newList;
        const parentKey = childList ? item.name : item.parentKey.split("~~")[1];
        const perentKeyLower = parentKey.toLocaleLowerCase();

        item.children.forEach((child) => {
            const microName = child.name.toLocaleLowerCase();
            const microChildList = child.children || child.tempChildren;
            const microNewList = microChildList ? getAllKeywordsInFolderObject(microChildList, mokbsMicrosegments?.[microName]?.list || []) : [{
                key: childName,
                name: item.name
            }];

            mokbsMicrosegments[microName] = {
                key: microName,
                name: child.name,
                list: microNewList
            }
        })
        if (!brandsOrigText[parentKey]) {
            const obj = {
                key: parentKey.toLocaleLowerCase(),
                name: parentKey,
                children: newList
            };
            brandsOrigText[parentKey] = obj;
            brandsOrigTextLower[perentKeyLower] = obj;
        } else {
            brandsOrigText[parentKey].children = brandsOrigText[parentKey].children.concat(newList);
            brandsOrigTextLower[perentKeyLower].children = brandsOrigTextLower[perentKeyLower].children.concat(newList);
        }
    });
    genericsArray.forEach((item) => {
        const childName = item.name.toLocaleLowerCase();
        const childList = item.children || item.tempChildren;
        const newList = childList ? getAllKeywordsInFolderObject(childList, generics[childName] || []) : [{
            key: childName,
            name: item.name
        }];
        generics[childName] = newList;
        const parentKey = childList ? item.name : item.parentKey.split("~~")[1];
        if (!genericsOrigText[parentKey]) {
            genericsOrigText[parentKey] = {
                key: parentKey.toLocaleLowerCase(),
                name: parentKey,
                children: newList
            };
        } else {
            genericsOrigText[parentKey].children = genericsOrigText[parentKey].children.concat(newList);
        }
    });

    const removeDuplicate = (mainObj) => Object.keys(mainObj).reduce((acc, key) => {
        const childrenObj = mainObj[key].children?.reduce((tempList, item) => {
            tempList[item.key] = item;
            return tempList;
        }, {});
        acc[key] = {
            ...mainObj[key],
            children: Object.values(childrenObj)
        };
        return acc;
    }, {});
    return {
        brandsArray,
        hcpsArray,
        genericsArray,
        hcpsOrigText,
        brandsOrigText: removeDuplicate(brandsOrigText),
        brandsOrigTextLower: removeDuplicate(brandsOrigTextLower),
        genericsOrigText,
        hcps,
        brands2ndChild,
        brands,
        mokbs,
        mokbsMicrosegments,
        generics
    };
};
const sortTreeFromConfig = (list, treeConfig) => {
    const moduleCode = getModuleCode()

    if (treeConfig?.treeSort?.[moduleCode]) {
        const namesMustIn1stBatch = treeConfig?.treeSort?.[moduleCode]
        const { firstBatch, secondBatch } = list.reduce((acc, obj) => {
            if (namesMustIn1stBatch.includes(obj.name)) {
                acc.firstBatch.push(obj)
            } else {
                acc.secondBatch.push(obj)
            }
            return acc
        }, {
            firstBatch: [], secondBatch: []
        })
        return [
            ...firstBatch,
            ...secondBatch,
        ]
    }
    return list
}

export const checkIfhasSetToDisplayOnly = async (defaultList, key = "behaviorsTree", treeConfig) => {
    const { hasConfig, list } = await checkIfhasSetToDisplayOnlyNew(defaultList, key, treeConfig)

    let filtered = defaultList;
    if (hasConfig) {
        filtered = list;
    } else {
        filtered = await checkIfhasSetToDisplayOnlyV2(defaultList, key, treeConfig);
    }
    return filtered
}
export const getTreeFilter = (treeConfig) => {
    const usergroupname = MainServices.getUserGroup()
    const moduleName = getModuleName()
    const path = `oneintelligence/treeFilter/${usergroupname}/${moduleName}/${(treeConfig.filterCode || treeConfig.code || treeConfig.key)}/treeFilter.json`;
    return MainServices.getFile(path)
}
export const checkIfhasSetToDisplayOnlyNew = async (list, key = "behaviorsTree", treeConfig) => {
    const filterConfig = await getTreeFilter(treeConfig);
    if (!filterConfig) {
        return {
            hasConfig: false,
            list: sortTreeFromConfig(list, treeConfig)
        }
    }
    try {
        const countryConfig = filterConfig[getCountryCode("enterprise")];
        if (!countryConfig) return {
            hasConfig: false,
            list: sortTreeFromConfig(list, treeConfig)
        }
        const {
            showOnly, showWith, hide, hideWith, hideAllExactExcept
        } = countryConfig;

        const tempShowOnly = (showOnly || []).map((t) => t.toLocaleLowerCase());
        const tempHideOnly = (hide || []).map((t) => t.toLocaleLowerCase());
        let newList = list.filter((d) => {
            if (hideAllExactExcept?.length && hideAllExactExcept.includes(d.namePath))
                return d;
            const loweredName = d.name.toLocaleLowerCase();
            const showOnlyFunction = (tValue) => {
                if (!showOnly?.length) return tValue;
                if (showOnly?.length && tempShowOnly.includes(loweredName)) {
                    return true;
                }
                if (showOnly?.length) {
                    if (
                        loweredName.includes(" : ") &&
                        tempShowOnly.find((t) =>
                            loweredName
                                .split(" : ")
                                .find((text) => text.trim() === t.toLocaleLowerCase())
                        )
                    )
                        return true;
                    else return false;
                }
                return tValue;
            };

            const showWithFunction = (tValue) => {
                if ([true, false].includes(tValue)) return tValue;
                if (showWith?.length) {
                    const found = showWith.find((t) => {
                        const foundWord = loweredName.split(/\s| /).find((text) => {
                            const tempText = text.trim();
                            if (tempText.includes("-")) {
                                const alltext = tempText.split("-").map((t) => t.trim());
                                if (alltext.includes(t.toLocaleLowerCase())) return true;
                            }
                            if (tempText === t.toLocaleLowerCase()) {
                                return true;
                            }
                            return false;
                        });
                        return foundWord;
                    });
                    if (found) return true;
                    return false;
                }
                return tValue;
            };

            const hideFunction = (tValue) => {
                if ([true, false].includes(tValue)) return tValue;
                if (hide?.length) {
                    if (tempHideOnly.includes(loweredName)) return true;
                    return (
                        loweredName.includes(" : ") &&
                        hide.find((t) =>
                            loweredName
                                .split(" : ")
                                .find((text) => text.trim() === t.toLocaleLowerCase())
                        )
                    );
                }
                return tValue;
            };

            const hideWithFunction = (tValue) => {
                if ([true, false].includes(tValue)) return tValue;
                if (hideWith?.length) {
                    const found = hideWith.find((t) => {
                        const foundWord = loweredName.split(/\s| /).find((text) => {
                            const tempText = text.trim();
                            if (tempText.includes("-")) {
                                const alltext = tempText.split("-").map((t) => t.trim());
                                if (alltext.includes(t.toLocaleLowerCase())) return true;
                            }
                            if (tempText === t.toLocaleLowerCase()) {
                                return true;
                            }
                            return false;
                        });
                        return foundWord;
                    });
                    return found;
                }
                return tValue;
            };

            const showOnlyResult = showOnlyFunction(d);
            const showWithResult = showWithFunction(d);

            let mustShow = false;
            if (showOnly?.length && showWith?.length) {
                mustShow = showOnlyResult || showWithResult;
            } else if (showOnly?.length) {
                mustShow = showOnlyResult;
            } else if (showWith?.length) {
                mustShow = showWithResult;
            } else {
                mustShow = true;
            }

            const hideWithResult = hideFunction(d);
            const hideContainsResult = hideWithFunction(d);

            let mustHide = false;
            if (hide?.length && hideWith?.length) {
                mustHide = hideWithResult || hideContainsResult;
            } else if (hide?.length) {
                mustHide = hideWithResult;
            } else if (hideWith?.length) {
                mustHide = hideContainsResult;
            }
            if (mustHide) return false;

            return mustShow;
        });
        return {
            hasConfig: true,
            list: sortTreeFromConfig(newList, treeConfig)
        }
    } catch (e) {
        return {
            hasConfig: false,
            list: sortTreeFromConfig(list, treeConfig)
        }
    }
};

export const checkIfhasSetToDisplayOnlyV2 = (list, key = "behaviorsTree", treeConfig) => {
    const state = getState();
    const {
        setup: {
            marketPackage
        }
    } = state.buildTargets;
    let newList = list;
    const permissions = ConfigServices.getCacheTreePermission() || {};
    let selectionTreeObj = permissions[key];
    if (!selectionTreeObj) {
        const foundKey = Object.keys(permissions).find((k) => k.split("~~").find((treeKey) => treeKey === key));
        if (foundKey) {
            selectionTreeObj = permissions[foundKey];
        }
    }
    if (!selectionTreeObj) return sortTreeFromConfig(list, treeConfig);
    const obj = selectionTreeObj[marketPackage.code.replace("dev", "")];
    if (obj) {
        const countryConfig = obj[getCountryCode("enterprise")];
        if (!countryConfig) return sortTreeFromConfig(list, treeConfig);
        const {
            showOnly, showWith, hide, hideWith, hideAllExactExcept
        } = countryConfig;

        const tempShowOnly = (showOnly || []).map((t) => t.toLocaleLowerCase());
        const tempHideOnly = (hide || []).map((t) => t.toLocaleLowerCase());
        newList = newList.filter((d) => {
            if (hideAllExactExcept?.length && hideAllExactExcept.includes(d.namePath)) return d;
            const loweredName = d.name.toLocaleLowerCase();
            const showOnlyFunction = (tValue) => {
                if (!showOnly?.length) return tValue
                if (showOnly?.length && tempShowOnly.includes(loweredName)) {
                    return true;
                }
                if (showOnly?.length
                    && loweredName.includes(" : ")
                    && tempShowOnly.find((t) => loweredName.split(" : ").find((text) => (text.trim() === t.toLocaleLowerCase())))) {
                    return true;
                }
                return tValue
            }

            const showWithFunction = (tValue) => {
                if (showWith?.length) {
                    const found = showWith.find((t) => {
                        if (loweredName.toLocaleLowerCase().includes("personas")) {
                            console.log(loweredName)
                            console.log(loweredName.split(/\s| /))
                        }
                        const foundWord = loweredName.split(/\s| /).find((text) => {
                            const tempText = text.trim();
                            if (tempText.includes("-")) {
                                const alltext = tempText.split("-").map((t) => t.trim())
                                if (alltext.includes(t.toLocaleLowerCase()))
                                    return true;
                            }
                            if (tempText === t.toLocaleLowerCase()) {
                                return true;
                            }
                            return false;
                        });
                        return foundWord;
                    });
                    if (found) return d;
                    else return false
                }
                return tValue
            }

            const hideFunction = (tValue) => {
                if (hide?.length && tempHideOnly.includes(loweredName)) {
                    return false;
                }
                if (hide?.length
                    && loweredName.includes(" : ")
                    && hide.find((t) => loweredName.split(" : ").find((text) => (text.trim() === t.toLocaleLowerCase())))) {
                    return false;
                }
                return tValue
            }

            const hideWithFunction = (tValue) => {
                if (hideWith?.length) {
                    const found = hideWith.find((t) => {
                        if (loweredName.toLocaleLowerCase().includes("personas")) {
                            console.log(loweredName)
                            console.log(loweredName.split(/\s| /))
                        }
                        const foundWord = loweredName.split(/\s| /).find((text) => {
                            const tempText = text.trim();
                            if (tempText.includes("-")) {
                                const alltext = tempText.split("-").map((t) => t.trim())
                                if (alltext.includes(t.toLocaleLowerCase()))
                                    return true;
                            }
                            if (tempText === t.toLocaleLowerCase()) {
                                return true;
                            }
                            return false;
                        });
                        return foundWord;
                    });
                    if (found) return false;
                }
                return tValue
            }
            let tempReturn = showOnlyFunction(d);
            if (tempReturn === true) return tempReturn
            tempReturn = showWithFunction(tempReturn);
            tempReturn = hideFunction(tempReturn);
            tempReturn = hideWithFunction(tempReturn);

            return tempReturn
        });
    }
    return sortTreeFromConfig(newList, treeConfig);
};

export const getMarketExplorerText = (selectedTarget) => {
    const { textObj, name, text } = selectedTarget || {};
    if (!textObj) return text || name;
    const packObj = getPackageObj();
    const OICode = getOICode()
    let tempObj = textObj?.[packObj.code.replace("dev", "")];
    if (!tempObj) tempObj = textObj?.[packObj.parent.code.replace("dev", "")];
    if (!tempObj) tempObj = textObj?.[OICode];
    if (tempObj) {
        const t = tempObj[getCountryCode("enterprise")];
        if (t !== undefined) {
            return t;
        }
        if (typeof tempObj === "string") return tempObj;
    }
    return text || name;
};

export const getDescription = (obj) => {
    const { description, descriptionObj = {} } = obj || {};
    if (!descriptionObj) return description;
    const packObj = getPackageObj();
    const OICode = getOICode()
    if (!packObj) return description;
    let tempObj = descriptionObj?.[packObj.code.replace("dev", "")];
    if (!tempObj) tempObj = descriptionObj?.[packObj.parent.code.replace("dev", "")];
    if (!tempObj) tempObj = descriptionObj?.[OICode];

    if (tempObj) {
        const t = tempObj[getCountryCode("enterprise")];
        if (t !== undefined) {
            return t;
        }
        if (typeof tempObj === "string") return tempObj;
    }
    return description;
};

export const getQuickReports = () => {
    const { quickReportsAndCountry, setup } = getState().buildTargets;
    const { country } = setup;
    if (!country) return [];
    return Object.values(quickReportsAndCountry[country.idMarketPackageModuleCountry]?.quickreport || {}).map((parentFolder) => {
        return {
            ...parentFolder,
            children: Object.values(parentFolder.children).sort(dynamicSort("name"))
        }
    }).sort(dynamicSort("name"));
};


export const getAudienceSizeHover = (item, parent) => {
    const { audienceSizeList } = getState("audienceSize");
    const { setup: { marketPackage } } = getState("buildTargets");
    const { audienceSizeHover = [] } = parent
    if (!audienceSizeHover.includes(marketPackage.code.replace("dev", ""))) return null
    let name = item.name
    if (item.namePath) name = `${item.namePath.replace("/", " - ")}***`;
    if (audienceSizeList[name])
        return `with an estimated ${formatNumber(audienceSizeList[name])} monthly engagements or content interactions`
    return null
}